import { render, staticRenderFns } from "./AgendaAtiva.vue?vue&type=template&id=2f1bca21"
import script from "./AgendaAtiva.vue?vue&type=script&lang=js"
export * from "./AgendaAtiva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports